import axios from "axios";
export default {
    getActionLogs: (type) => `/ActionLog/GetActionLogs?Type=${type}`,
    getActionLogEventTypeDictionary: () => axios.post("/ActionLog/GetActionLogEventTypeDictionary", {}),
    getActionLogUsers: () => axios.post("/ActionLog/GetActionLogUsers", {}),
    getActionLogProjects: () => axios.post("/ActionLog/GetActionLogProjects", {}),
    export: (type, filter, sort) => axios.post("/ActionLog/Export", { type, filter, sort }, {
        responseType: "blob"
    })
};
